import React from 'react';
import { useTranslation } from 'react-i18next';

const ProjectTypeFilter = ({ searchData, filterData }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <div className="inline-flex items-center px-1.5 py-1 border border-gray-100 rounded-md bg-white">
        <button
          className={`card-skeleton-align-padding ${
            filterData?.investmentType === ''
              ? 'bg-brandBlue text-white '
              : 'bg-white text-brandBlue'
          }`}
          onClick={() => searchData('investmentType', '')}
        >
          {t('all')}
        </button>
        <button
          className={`card-skeleton-align-padding ${
            filterData?.investmentType === 'asset'
              ? 'bg-brandBlue text-white '
              : 'bg-white text-brandBlue'
          }`}
          onClick={() => searchData('investmentType', 'asset')}
        >
          {t('common:equity')}
        </button>
        <button
          className={`card-skeleton-align-padding ${
            filterData?.investmentType === 'bond'
              ? 'bg-brandBlue text-white '
              : 'bg-white text-brandBlue'
          }`}
          onClick={() => searchData('investmentType', 'bond')}
        >
          {t('common:bonds')}
        </button>
      </div>
    </>
  );
};

export default ProjectTypeFilter;
